// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ChevronRight = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChevronRight = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ChevronRight = _exports.ChevronRight = function ChevronRight(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.30506 17.6994C5.95078 17.3082 5.86541 16.6649 6.3097 16.2217L12.5432 9.99961L6.30554 3.77711C5.8286 3.26171 5.99136 2.62312 6.30624 2.30861C6.65032 1.96479 7.25 1.83594 7.78601 2.30836L14.7626 9.24974C15.1728 9.60521 15.1923 10.3357 14.7626 10.7302L7.78726 17.6994C7.38199 18.1074 6.70078 18.0856 6.30506 17.6994Z",
      fill: "currentColor"
    }));
  };
});
